var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-content main-crm-content" }, [
      _c("div", { staticClass: "container content-title" }, [
        _c("img", {
          staticClass: "img-box",
          attrs: { src: require("static/images/trait/yy.png"), alt: "oa" }
        }),
        _c("h3", { staticClass: "services-title1" }, [_vm._v("系统应用")])
      ]),
      _c("div", { staticClass: "container new-list" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd3d90b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd3d90b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/application/Content.vue
// module id = c6rf
// module chunks = 17